import { type FieldValue } from "~/components/job_posts/field";
import { useBoardConfiguration } from "~/hooks/use_board_configuration";
import { type PhoneError, PhoneInput } from "~/components/phone_input";

interface Props {
  label: string;
  name: string;
  required: boolean;
  countryError: string | null | undefined;
  phoneError: string | null | undefined;
  value: string | null;
  onChange: (value: FieldValue) => void;
  onError: (error: PhoneError | null) => void;
  onFocus: () => void;
}

const PhoneField = ({
  label,
  name,
  required,
  countryError,
  phoneError,
  value,
  onChange,
  onError,
  onFocus,
}: Props) => {
  const { outside_label: outsideLabel } = useBoardConfiguration();

  return (
    <PhoneInput
      id={name}
      label={label}
      required={required}
      countryError={countryError}
      phoneError={phoneError}
      maxLength={255}
      outsideLabel={outsideLabel}
      value={value}
      onChange={onChange}
      onError={onError}
      onFocus={onFocus}
    />
  );
};

export default PhoneField;
